import * as React from 'react';

import AccessibleSVG from '../accessible-svg';
import { TwoTonedIcon } from '../iconTypes';

const IconMetadataColumns = ({ className = '', height = 16, title, width = 16 }: TwoTonedIcon) => (
    <AccessibleSVG
        className={`metadata-columns ${className}`}
        height={height}
        title={title}
        viewBox="0 0 16 16"
        width={width}
    >
        <path d="M12,4 L12,2 L13,2 L13,4 L15,4 L15,5 L13,5 L13,7 L12,7 L12,5 L10,5 L10,4 L12,4 Z M1.5,2 L3.5,2 C3.77614237,2 4,2.22385763 4,2.5 L4,13.5 C4,13.7761424 3.77614237,14 3.5,14 L1.5,14 C1.22385763,14 1,13.7761424 1,13.5 L1,2.5 C1,2.22385763 1.22385763,2 1.5,2 Z M5.5,2 L7.5,2 C7.77614237,2 8,2.22385763 8,2.5 L8,13.5 C8,13.7761424 7.77614237,14 7.5,14 L5.5,14 C5.22385763,14 5,13.7761424 5,13.5 L5,2.5 C5,2.22385763 5.22385763,2 5.5,2 Z" />
    </AccessibleSVG>
);

export default IconMetadataColumns;
